import React, { Component, useState } from "react";
import ReactPlayer from "react-player"
// import { ReactVideo } from "reactjs-media";
// import myVideo from "../src/Untitled.mp4"
import logo from "../src/RoundTableLogo.png"
import step1 from "../src/pictures/step1.png"
import step2 from "../src/pictures/step2.png"
import step3 from "../src/pictures/step3.png"
import step4 from "../src/pictures/step4.png"
import step5 from "../src/pictures/step5.png"
import step6 from "../src/pictures/step6.png"
import step7 from "../src/pictures/step7.png"
import step8 from "../src/pictures/step8.png"
import step9 from "../src/pictures/step9.png"
import step10 from "../src/pictures/step10.png"
import StepLayout from "../src/StepLayout"

import { Row, Col } from 'reactstrap'
import SimpleFooter from "./views/examples/components/Footers/SimpleFooter";
// const [videoFilePath, setVideoFilePath] = useState(null);

// const handleVideoUpload = (event) => {
// setVideoFilePath(URL.createObjectURL(event.target.files[0]));
// };

export default class Circles extends Component {
  render() {
    return (
      <div className='about' style={{ backgroundColor: 'white', height: '95vh' }}>
        <div className='container' style={{ paddingTop: '70px' }}>
          <br />
          <h1 className="display-2 text-black" style={{
            background: '-webkit-linear-gradient(top right,  #6EA59A, #867fd7)',
            webkitBackgroundClip: 'text',
            webkitTextFillColor: 'transparent',
            fontSize: '50px'
          }}>RoundTable Walkthrough</h1>
          {/* <text>Please contact us at hello@makeroundtable.com if you are interested in a product demo.</text> */}
          {/* <text>We have included a video product walkthrough below.<br></br> Please contact us at hello@makeroundtable.com if you are interested in a product demo.</text> */}
          {/* <br /><br /> */}
          {/* <ReactPlayer url={myVideo} width="1000px" height="500px" controls={true} /> */}
          <ReactPlayer
            url={"https://www.youtube.com/watch?v=ZJ0PWws_lX0&ab_channel=RoundTableTeam"}
            // poster={logo}
            width="1000px"
            height="500px"
          // primaryColor="red"
          // other props
          />
          <br></br>
          <h2 className="display-2 text-black" style={{
            background: '-webkit-linear-gradient(top right,  #6EA59A, #867fd7)',
            webkitBackgroundClip: 'text',
            webkitTextFillColor: 'transparent',
            fontSize: '50px'
          }}>Step by Step Walkthough</h2>
          <br />
          <StepLayout img={step1} title={'Step 1: Create your Circle'}
            description={'After connecting your MetaMask account, you can now create a Circle. Enter your name, the name of your Circle, and the symbol you would like to assign the Circle. You can invite members to your Circle by entering their corresponding wallet address and name. After adding all members, you can click the Create button to launch your Circle.'} />
          <br />
          <StepLayout img={step2} title={'Step 2: Open your Circle'}
            description={'By clicking the Browse Circles tab, you can see all the Circles on RoundTable including the ones you have created. To view more details about each Circle you can click "Open Circle".'} />
          <br />
          <StepLayout img={step3} title={'Step 3: Launch Proposal to Circle'}
            description={'Within the details of each Circle, you can click "Create New Proposal" to launch a proposal that other members in your Circle can vote on.'} />
          <br />
          <StepLayout img={step4} title={'Step 4: Enter Proposal Details'}
            description={'Submit a short title for your proposal, as well as a yes/no proposal question.'} />
          <br />
          <StepLayout img={step5} title={'Step 5: Start Voting'}
            description={'After entering the proposal details, click on "Start Voting" to publicly post the proposal on the your Circle page for others to vote on.'} />
          <br />
          <StepLayout img={step6} title={'Step 6: Enter Voting Page'}
            description={'Each member in the Circle can then view the proposal and click the vote button to voice their decision on the question.'} />
          <br />
          <StepLayout img={step7} title={'Step 7: Cast your Vote'}
            description={'The user is now directed to the page where they can cast their vote to the question that was proposed by clicking the "Yes" or "No" button. The corresponding proposal address is automatically filled in. The user can also view specific details about the proposal before casting a vote.'} />
          <br />
          <StepLayout img={step8} title={'Step 8: Your Vote has been Cast'}
            description={'Upon casting a vote successfully, the question panel will say that the user has voted and cannot recast their vote another time.'} />
          <br />
          <StepLayout img={step9} title={'Step 9: End Voting'}
            description={'The creator of the proposal can "End Voting," at which time no more votes can be cast by any member in the Circle.'} />
          <br />
          <StepLayout img={step10} title={'Step 10: View Results'}
            description={'All members of the Circle can view the results of the votes. Voting is kept anonymous.'} />
        </div>
        <SimpleFooter></SimpleFooter>
      </div>
    );
  }
}
